export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    expanded: boolean | undefined
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            expanded: false,
        };
    }

    @bind
    toggleExpanded() {
        this.set('expanded', !this.get('expanded'));
    }
}